import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Paper,  TextField, Typography, useTheme } from "@mui/material"
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {ReactComponent as SunIcon} from '../../../assets/images/mi-portal/request-vacations/sun-setting-03.svg';
import CheckIcon from '@mui/icons-material/Check';
import dayjs, { Dayjs } from 'dayjs';

import './index'
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { S10CouponsTypesResponse } from "../../../interfaces/s10Employees.interface";
import MyDatepicker from "../../../components/my-datepicker";
import { useLocation } from "react-router-dom";
import { uploadFilesToFilestorage } from "../../../utils/media-files";
import { getEmployeeVacationsResume, signalGetCouponstData, validateCouponDateRange } from "../../../api/signalApi";
import { getCouponsTypes, requestCouponRange, sendEmailCouponNotification, setCouponsTypesError, setCouponsTypesSuccess, setFlowId } from "../../../store/slices/userRequests";
import { addOrUpdateGroupId } from "../../../api/fileStorage";
import { FileStorageS10Data } from "../../../interfaces/fileStorage.interface";
import MySnackbar from "../../../components/MySnackbar";
import ListFilesToUpload from "../../../components/ListFilesToUpload";
import { UserVacationsResume } from "../../../interfaces/auth.interface";
import TableCoupons from "../documents/TableCoupons";
import ThreeComponent from "../../../components/ThreeColumnsComponent";
import MySelectAssignedCompany from "../../../components/MySelectAssignedCompany";


const ResumeComponent = ({
    data,
}: {
    data: UserVacationsResume[],

}) => {
    const theme = useTheme();
    const [resumenIsVisible, setResumenIsVisible] = useState(false);

    const vacationsResume = [
        {label: "Total días acumulados", value: data[0]?.DiasGanados},
        {label: "Total días solicitados", value: data[0]?.DiasProgramado},
        ...(!data[0]?.DiasUtilizado ? [] : [{label: "Total días utilizados", value: data[0]?.DiasUtilizado}]),
        {label: "Por utilizar", value: data[0]?.DiasPorUtilizar},
        {label: "Por solicitar", value: data[0]?.SaldoProgramado},
    ]

    return (
        <>
            <Paper 
                elevation={3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    // minHeight: "10rem",
                    padding: "2rem",
                    paddingBottom: ".5rem",
                    marginBottom: "1rem",
                }}
            >
                <Grid container direction="column" style={{transition: "all 0.2s ease",}}>
                    <Grid container item style={{minHeight: "2rem", transition: "all 0.2s ease",}}>
                        <Grid container direction="row" justifyContent="flex-start" alignItems="center" item xs={6}>
                            <Grid 
                                container direction="row" justifyContent="center" alignItems="center"
                                style={{width: "2rem", height: "2rem", backgroundColor: "#FBEFE7", marginRight: "1rem"}}
                            >
                                <SunIcon />
                            </Grid>
                            <Typography variant="h6" style={{color: theme.s10palette.S10Greygrey600, marginRight: "0.5rem"}}>
                                {data[0]?.SaldoProgramado}
                            </Typography>
                            <Typography variant="subtitle1" style={{color: theme.s10palette.S10Greygrey600, fontWeight: "500"}}>
                                Días disponibles
                            </Typography>
                        </Grid>
                        <Grid container item xs={6} justifyContent="flex-end" alignItems="center">
                            <CalendarTodayIcon style={{marginRight: ".5rem"}}/>
                            <Typography variant="subtitle1" style={{color: theme.s10palette.S10Greygrey600, fontWeight: "500"}}>
                                    A hoy
                            </Typography>
                        </Grid>
                    </Grid>
                    <Divider style={{marginTop: ".5rem", marginBottom: ".5rem"}} />
                    {resumenIsVisible && <Grid className="vacations-resume">
                        {vacationsResume.map( (r, i) => (
                            <div key={i}>
                            <Grid  container direction="row" justifyContent="space-between" padding={"1rem 0"}>
                                <Grid item>
                                    <Typography variant="subtitle1">
                                        {r.label}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1">
                                        {r.value?.toFixed(2)} días
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Divider style={{marginTop: "0", marginBottom: "0"}} />
                            </div>
                        ))}
                        {/* <Grid container direction="row" justifyContent="space-between" padding={"1rem 0"}>
                            <Grid item>
                                <Typography variant="subtitle1" style={{fontSize: "1rem", fontWeight: 700}}>
                                    Saldo
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="subtitle1" style={{fontSize: "1rem", fontWeight: 700}}>
                                    {data[0]?.Saldo} días
                                </Typography>
                            </Grid>
                        </Grid> */}
                        <Divider style={{marginTop: "0", marginBottom: "0"}} />
                    </Grid>}
                    <Grid container item style={{ width: "100%"}} justifyContent="center">
                        <Button 
                            size="small"
                            variant="text" 
                            onClick={() => setResumenIsVisible(!resumenIsVisible)}
                        >
                            { resumenIsVisible
                                ? <ExpandLessIcon style={{marginRight: ".5rem"}} />
                                : <ExpandMoreIcon style={{marginRight: ".5rem"}} />
                            }
                            { resumenIsVisible
                                ? "Ocultar detalle"
                                : "Ver detalle"
                            }
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
}

const UseTypePerDays = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
}: any) => {

    return (
        <>
            <Grid item xs={12}>
                <MyDatepicker 
                    labelText="Fecha de inicio"
                    value={startDate}
                    // minDate={dayjs()}
                    setSelectedDate={(value) => {
                        setStartDate(value?.endOf('day'));
                        if (endDate) {
                            const dateDaysDiff = dayjs(value).diff(endDate, 'day');
                            if (dateDaysDiff < 0) {
                                setEndDate(null)
                            }
                        }
                        // setEndMaxDate(value?.add(userAvailableDays, 'days'));
                    }}
                    
                />
            </Grid>
            <Grid item xs={12}>
                <MyDatepicker 
                    labelText="Fecha de término"
                    value={endDate}
                    minDate={startDate}
                    // maxDate={endMaxDate}
                    setSelectedDate={(value: Dayjs | null) => setEndDate(value?.endOf('day'))}
                />
            </Grid>
        </>
    );
}

const RequestVacationComponent = ({
    couponTypeSelected, 
    loading, 
    setLoading,
    rucSelected,
    setRucSelected,
}: any) => {
    
    const theme = useTheme();
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, userVacationsResume} = useSelector((state: RootState) => state.auth);
    const {assignedCompanies} = useSelector((state: RootState) => state.userRequests);
    const {requestCoupon} = useSelector((state: RootState) => state.userRequests);
    
    const [comment, setComment] = useState<string>("");
    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs());
    const [endDate, setEndDate] = useState<Dayjs | null>(null);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    
    useEffect( () => {
        if (!companyselected?.Code || !startDate || !endDate) {
            return;
        }
        if (couponTypeSelected?.CouponType !== 0) {
            return;
        }
        validateCouponDateRange(startDate.toDate(), endDate.toDate());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endDate]);
    
    
    useEffect( () => {
        handleReset()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestCoupon.flowId]);
    
    const handlerRequestCoupon = async () => {
        if(requestCoupon.couponsTypesLoading || !companyselected) {
            return;
        }
        if(!couponTypeSelected) {
            handlerSetErrorMsg("No fue posible cargar el tipo de cupón.");
            return;
        }
        if (!handlerValidateRequest()) {
            handlerSetErrorMsg("Rango de fechas no válido.");
            return;
        }
        if (!startDate || !endDate) return
        setLoading(true);
        let filestorageData: FileStorageS10Data[] = [];
        let groupId = "";
        if (selectedFiles.length) {
            const result = await uploadFilesToFilestorage(selectedFiles, handlerSetErrorMsg, false);
            if (!result) {
                setLoading(false);
                return;
            }
            filestorageData = result.filestorageData;
            groupId = result.groupId;
            const updateGroupId = await addOrUpdateGroupId(filestorageData);
            if (updateGroupId?.Type !== 0) {
                handlerSetErrorMsg(updateGroupId?.Message || "Error registrando la información en s10.");
                setLoading(false);
                return;
            }
        }
        const companyData = assignedCompanies.find(c => c.RUCEmpresa === rucSelected);
        dispatch(requestCouponRange(
            couponTypeSelected,
            startDate?.format('YYYY-MM-DDTHH:mm:ss'),
            endDate?.format('YYYY-MM-DDTHH:mm:ss'),
            comment,
            groupId,
            filestorageData.length,
            companyData?.RUCEmpresa,
            companyData?.DescripcionEmpresa            
        ));
        setLoading(false);
    }

    const handleReset = () => {
        setComment("");
        setStartDate(null);
        setEndDate(null);
        // setCouponTypeSelected(null);
        setSelectedFiles([])
        dispatch(setCouponsTypesSuccess(""));
    }

    const handlerValidateRequest = () => {
        if (!couponTypeSelected || loading) {
            return false;
        }
        if (couponTypeSelected.ForcedAttach && selectedFiles.length === 0) {
            return false;
        }
        if (couponTypeSelected.CouponType === 0 && !requestCoupon.rangeSelectedIsValid) {
            return false;
        }
        if (!startDate || !endDate || startDate > endDate) {
            return false;
        }
        return true;
                            
    }

    const handlerSetErrorMsg = (msg: string) => {
        dispatch(setCouponsTypesError(msg));
    }

    return (
        <>
            <Grid mb='1em'>
                <MySelectAssignedCompany
                    setRucSelected={(value) => {
                        setRucSelected(value);
                    }}
                    rucSelected={rucSelected}
                    minWidth='100%'
                />
            </Grid>
            <ResumeComponent 
                key={`${new Date().toISOString()}-${rucSelected}`} 
                data={userVacationsResume}
            />
            <Paper 
                key={requestCoupon.flowId}
                elevation={3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    minHeight: "10rem",
                    padding: "1rem"
                }}
            >
                <Grid container direction="row">
                    <UseTypePerDays
                        startDate={startDate}
                        setStartDate={(value: any) => {
                            setStartDate(value)
                        }}
                        endDate={endDate}
                        setEndDate={(value: any) => {
                            handlerSetErrorMsg("")
                            setEndDate(value)
                        }}
                    />
                </Grid>
                <Grid container direction="column" style={{marginTop: ".5rem", width: "100%"}}>
                    <Grid item>
                        <label 
                            style={{
                                color: "#666",
                                fontFamily: "Roboto",
                                fontSize: ".875rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                            }}
                        >
                            Comentario:
                        </label>
                    </Grid>
                    <Grid item width={"100%"}>
                        <TextField
                            style={{
                                width: "100%",
                                borderRadius: "0.25rem",
                                height: "auto !important",
                            }}
                            onChange={({target}) => setComment(target.value)}
                            // value={comment}
                            fullWidth
                            rows={2}
                            hiddenLabel
                            variant="outlined"
                            multiline={true}
                        />
                    </Grid>
                    {couponTypeSelected && 
                        <Grid item width={"100%"} marginTop="1rem">
                            <ListFilesToUpload
                                setSelectedFiles={setSelectedFiles} 
                                selectedFiles={selectedFiles}
                                buttonLabel={`Agregar sustento (${couponTypeSelected.ForcedAttach ? "requerido" : "opcional"})`}
                                filesLimit={2}
                            />
                        </Grid>
                    }
                </Grid>
                <Grid 
                    container 
                    direction="row" 
                    style={{marginTop: "1.5rem", width: "100%"}}
                    justifyContent="space-between"
                >
                    <Grid item xs={12}>
                        <Button 
                            key={`${requestCoupon.rangeSelectedIsValid}`}
                            className="my-button"
                            variant="contained"
                            style={{
                                width: "100%",
                                height: "2.5rem",
                                display: "inline-flex",
                                padding: "0.625rem 1.5rem",
                                justifyContent: "center",
                                alignItems: "center",
                                gap:" 0.5rem",
                                flexShrink: 0,
                                backgroundColor: theme.s10palette.S10Blueblue600
                            }}
                            // disabled={!requestIsValid}
                            startIcon={<CheckIcon />}
                            onClick={handlerRequestCoupon}
                        >

                            {loading ? "Solicitando..." : "Solicitar"}
                            
                        </Button>
                    </Grid>
                    {/* <Grid item xs={12} marginTop={"1rem"}>
                        <Button 
                            className="my-button"
                            variant="outlined"
                            style={{
                                width: "100%",
                                height: "2.5rem",
                                display: "inline-flex",
                                padding: "0.625rem 1.5rem",
                                justifyContent: "center",
                                alignItems: "center",
                                gap:" 0.5rem",
                                flexShrink: 0,
                                color: theme.s10palette.S10Blueblue600
                            }}
                            startIcon={<CloseIcon className=".icon-button"/>}
                        >
                            Cancelar
                        </Button>
                    </Grid> */}
                </Grid>
            </Paper>
            <MySnackbar
                open={requestCoupon.couponsTypesError !== ""}
                msg={requestCoupon.couponsTypesError}
                severity="error"
                onClose={() =>  handlerSetErrorMsg("")}
            />
        </>
    )
    
}

const RequestVacations = () => {
    const location = useLocation();
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, userVacationsResume} = useSelector((state: RootState) => state.auth);
    const {requestCoupon} = useSelector((state: RootState) => state.userRequests);
    const [couponTypeSelected, setCouponTypeSelected] = useState<S10CouponsTypesResponse | null>();
    const [requestedAt, setRequestedAt] = useState(new Date());
    const refLoading = useRef<boolean>(false)
    const [rucSelected, setRucSelected] = useState<string>("");


    const handleGetCouponsTypes = () => {
        if (requestCoupon.couponsTypesLoading || refLoading.current || !companyselected || refLoading.current) return;
        dispatch(getCouponsTypes(1));
    };

    useEffect( () => {
        if (!companyselected?.Code || refLoading.current || !location.pathname) {
            return;
        }
        if (!requestCoupon.couponsTypesLoading) {
            handleGetCouponsTypes();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, companyselected])
    
    useEffect( () => {
        if (!companyselected?.Code || refLoading.current || !couponTypeSelected) {
            return;
        }
        refLoading.current = true;
        getEmployeeVacationsResume(rucSelected).finally(() => {
            refLoading.current = false;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, couponTypeSelected, rucSelected])

    useEffect( () => {
        if(!requestCoupon.useEmployeeCouponResponsablesData.length) return;
        dispatch(sendEmailCouponNotification());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestCoupon.useEmployeeCouponResponsablesData])

    useEffect( () => {
        // refLoading.current = false;
        // setCouponTypes(requestCoupon.couponsTypes);
        setCouponTypeSelected(requestCoupon.couponsTypes[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestCoupon.couponsTypes])
    
    useEffect( () => {
        console.log('---- requestCoupon.couponsTypesError', requestCoupon.couponsTypesError, 'requestCoupon.couponsTypes.length', requestCoupon.couponsTypes.length)
        if (!requestCoupon.couponsTypesError || requestCoupon.couponsTypes.length > 0) {
            return
        }
        getCouponsData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestCoupon.couponsTypesError, requestCoupon.couponsTypes])

    const getCouponsData = async () => {
        // setLoadingImportingCouponData(true);
        const {data} = await signalGetCouponstData();
        await new Promise(resolve => setTimeout(resolve, 3000));
        console.log(data)
        if (data?.isSuccess) {
            dispatch(getCouponsTypes(1));
            console.log("Se ha refrescado la información de tipos de cupones.");
        } else {
            console.warn(`Error refrescando la informacion de tipos de cupones: ${data?.message || ''}`)
        }
    }


    const ComponentOne = useCallback(() => (
        <RequestVacationComponent 
            couponTypeSelected={couponTypeSelected}
            setLoading={(loading: boolean) => {refLoading.current = loading;} }
            loading={refLoading.current}
            rucSelected={rucSelected}
            setRucSelected={setRucSelected}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [couponTypeSelected, requestedAt, rucSelected, userVacationsResume]);

    const ComponentTwo = useCallback(() => (
        <TableCoupons 
            numberOfCards={1} 
            changeViewOptionHidden={true} 
            hiddenBottomPaginator={true} 
            status={'-4'}
            type={"-1"}
            onlyPendings={true}
            hiddenFilter={true}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [couponTypeSelected?.Code, requestedAt]);

    const ComponentThree = useCallback(() => (
        <TableCoupons
            key={couponTypeSelected?.Code}
            numberOfCards={1}
            status={'-3'}
            type={"-1"}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [couponTypeSelected?.Code]);

    return (
        <Grid key={location.pathname} container spacing="1rem" >
            <ThreeComponent
                tabsTitle={["Solicitar", "Pendientes", "Histórico"]}
                useTabsNameAsTitle={true}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
            <Dialog
                open={requestCoupon.couponsTypesSuccess !== ""}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle 
                    id="responsive-dialog-title" 
                    style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                    variant="h5"
                >
                    Solicitud enviada
                </DialogTitle>
                <DialogContent style={{width: "100%", height: "50%", padding: "0 1.5rem", textAlign: "center"}}>
                    La solicitud de vacaciones fue enviado con éxito.
                </DialogContent>
                <DialogActions>
                    <Grid container>
                        <Grid item margin={"1.5rem 1.5rem 2.5rem 1.5rem"} padding={0} textAlign="center" xs={12}>
                            <Button 
                                variant="contained" 
                                style={{width: "8rem"}}
                                startIcon={<CheckIcon style={{height: "1rem"}} />}
                                disabled={refLoading.current}
                                onClick={() => {
                                    dispatch(setCouponsTypesSuccess(""));
                                    dispatch(setFlowId());
                                    setRequestedAt(new Date());
                                }}
                            >
                                Aceptar
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </Grid>
    )

}

export default RequestVacations